// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__z6OUv","formSpace":"styles_formSpace__DXGHb","actionButton":"styles_actionButton__3Iwgd","actionIcon":"styles_actionIcon__2Lr-I"};